import React, { useEffect, useState } from "react";
import { resolveTaxonomyDefinitions } from "./taxonomyApi";
import { displayTaxonomyValue, historicalFields } from "./values";
import { customFieldsCopy } from "./copy";
import type { ResolvedFieldConfig, TaxonomyDefinition, TaxonomyValues } from "./types";

export default function HistoricalTaxonomyValues({ values, fields }: {
  values?: TaxonomyValues; fields: ResolvedFieldConfig[];
}) {
  const [definitions, setDefinitions] = useState<TaxonomyDefinition[]>([]);
  const [error, setError] = useState(false);
  const idsKey = JSON.stringify(Object.keys(values || {}).filter(
    (id) => !fields.some((field) => field.taxonomyId === id && field.enabled)).sort());
  useEffect(() => {
    let current = true;
    setDefinitions([]);
    setError(false);
    resolveTaxonomyDefinitions(JSON.parse(idsKey)).then((res) => {
      if (!current) return;
      setDefinitions(res.data || []);
      setError(!res.success);
    });
    return () => { current = false; };
  }, [idsKey]);
  const archived = historicalFields(values, fields, definitions);
  if (!archived.length) return null;
  return <div className="hkp-tax-historical">
    <p className="text-muted mb-2">{customFieldsCopy.historicalTitle}</p>
    {error ? <p role="status">Historical labels could not be loaded. Saved values are preserved.</p> : null}
    {archived.map((field) => <p className="mb-1" key={field.taxonomyId}>
      <span className="text-muted">{field.name}:</span> {displayTaxonomyValue(field, values?.[field.taxonomyId])}
    </p>)}
  </div>;
}
